import axios from "axios";

export const createDeal = async (deal, authtoken) =>
  await axios.post(`${process.env.REACT_APP_API}/deal`, deal, {
    headers: {
      authtoken,
    },
  });

  export const createBanner = async (banner, authtoken) =>
  await axios.post(`${process.env.REACT_APP_API}/create-banner`, banner, {
    headers: {
      authtoken,
    },
  });

  export const getDeals = async () =>
  await axios.get(`${process.env.REACT_APP_API}/deals`);

  export const getBanners = async () =>
  await axios.get(`${process.env.REACT_APP_API}/banners`);

  export const removeDeal = async (slug, authtoken) =>
  await axios.delete(`${process.env.REACT_APP_API}/deal/${slug}`, {
    headers: {
      authtoken,
    },
  });

  export const removeBanner = async (slug, authtoken) =>
  await axios.delete(`${process.env.REACT_APP_API}/banner/${slug}`, {
    headers: {
      authtoken,
    },
  });

  export const killDeals = async () =>
  await axios.post(`${process.env.REACT_APP_API}/products/deal-kill`);

  export const addStock = async () =>
  await axios.post(`${process.env.REACT_APP_API}/products/add-stock`);

  export const getDeal = async (slug) =>
  await axios.get(`${process.env.REACT_APP_API}/deal/${slug}`);

  export const updateDeal = async (slug, values, authtoken) =>
  await axios.put(`${process.env.REACT_APP_API}/deal/${slug}`, values, {
    headers: {
      authtoken,
    },
  });

  export const getProductsDeal = async () =>
  await axios.get(`${process.env.REACT_APP_API}/deal-products`);
